_ = require 'underscore'
pluginValidators = require 'app/scripts/lib/plugins/plugin-validators'
PluginView = require 'app/scripts/views/plugin/plugin-view'
PopOver = require 'app/scripts/views/lib/pop-over'
Promise = require 'bluebird'
t = require('app/scripts/views/internal/teacup-with-helpers')('plugin_popover')

template = t.renderable ({ message, confirmText, confirmStyle, cancelText }) ->
  t.p ->
    t.text message

  t.input '.js-confirm.full',
    type: 'submit'
    class: if confirmStyle == 'danger' then 'negate' else 'primary'
    value: confirmText

  if cancelText
    t.input '.js-cancel.full',
      type: 'submit'
      value: cancelText

module.exports = class PluginPopOverConfirmView extends PluginView
  initialize: ({ @title, @content }) ->
    @retain(@content)

  getViewTitle: -> @title

  keepInDOM: true

  events: ->
    'click a[href]': (e) ->
      PopOver.hide()
    'click .js-confirm': (e) =>
      if _.isFunction(@content.onConfirm)
        @content.onConfirm({ el: e.currentTarget }).catch (err) ->
          console?.warn "Error running Power-Up onConfirm function: #{err.message}"
      else
        PopOver.popView()
    'click .js-cancel': (e) ->
      if _.isFunction(@content.onCancel)
        @content.onCancel({ el: e.currentTarget }).catch (err) ->
          console?.warn "Error running Power-Up onCancel function: #{err.message}"
      else
        PopOver.popView()

  renderOnce: ->
    @$el.html(template(@content))

    @
